import * as React from 'react'
import { motion, Transition, Variants } from 'framer-motion'
import { twMerge } from 'tailwind-merge'
import { Dialog } from '@highlight/ui'

interface ModalPopupProps extends React.ComponentProps<typeof Dialog.Popup> {
  className?: string
}

const popupVariants: Variants = {
  initial: { opacity: 0, scale: 0.95, x: '-50%', y: '-50%' },
  animate: { opacity: 1, scale: 1, x: '-50%', y: '-50%' },
  exit: { opacity: 0, scale: 0.95, x: '-50%', y: '-50%' },
}
const popupTransition: Transition = { duration: 0.15, ease: 'easeOut' }

export function ModalPopup({ className, children, ...props }: ModalPopupProps) {
  return (
    <Dialog.Popup
      render={
        <motion.div
          variants={popupVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={popupTransition}
        />
      }
      className={twMerge(
        // Remove CSS transitions from base UI
        '[transition:none]',
        className,
      )}
      {...props}
    >
      {children}
    </Dialog.Popup>
  )
}
